import React, { useContext, useEffect, useReducer, useState, useRef, useMemo, useCallback } from "react";
import { Modal, Switch, Button } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import Header from "./HeaderNew";
import Footer from "./Footer";
import Sider from './Sider';
import styles from './index.module.scss'
import Router from "../../Routes"
import MainContext from '../../stores/stores'
import accountApi from "../../api/accountApi";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { AliveScope } from 'react-activation'
import axios from "axios";
import { useIntl } from 'react-intl'

// import SDK from '@yxim/nim-web-sdk'

import {
  Provider, // 全局上下文
} from '@/YXUIKit/im-kit-ui/src'
//UIKit 国际化
import en from '@/components/IMApp/locales/en'
import zh from '@/components/IMApp/locales/zh'
import ru from '@/components/IMApp/locales/ru'
import cht from '@/components/IMApp/locales/cht';
import tr from '@/components/IMApp/locales/tr';
import ara from '@/components/IMApp/locales/ara';
import pt from '@/components/IMApp/locales/pt'
import vie from '@/components/IMApp/locales/vie';
import fra from '@/components/IMApp/locales/fra'
import { LocalOptions } from "@xkit-yx/im-store-v2/dist/types/types";
import V2NIM from "nim-web-sdk-ng";
import { V2NIMConst } from "nim-web-sdk-ng/dist/esm/nim";
import { V2NIMAIUser } from "nim-web-sdk-ng/dist/esm/nim/src/V2NIMAIService";
import orderApi from "@/api/orderApi";
import commonApi from "@/api/commonApi";


type MainContentProps = {
  pageType: string,
  market: number
}

const reducer = (state: any, action: any) => {
  switch(action.type) {
    case 'userInfo':
      return {
        ...state,
        userInfo: action.value
      };
    case 'areaOptions':
      return {
        ...state,
        areaOptions: action.value
      };
    case 'cartNum':
      return {
        ...state,
        cartNum: action.value
      }
    case 'lang': 
      return {
        ...state,
        lang: action.value
      }
    case 'pageType': 
      return {
        ...state,
        pageType: action.value
      }
    case 'headerInfo':
      return {
        ...state,
        headerInfo: action.value
      }
    case 'logo': 
      return {
        ...state,
        logo: action.value
      }
    case 'epc_page_logo':
      return {
        ...state,
        epc_page_logo: action.value
      }
    case 'epc_barnds':
      return {
        ...state,
        epc_barnds: action.value
      }
    case 'isWomala': 
      return {
        ...state,
        isWomala: action.value
      }
    case 'webData': 
      return {
        ...state,
        webData: action.value
      }
    case 'host': 
      return {
        ...state,
        host: action.value
      }
    case 'crumb':
      return {
        ...state,
        crumb: action.value
      }
    case 'vinData':
      return {
        ...state,
        vinData: action.value
      }
    case 'colorPrimary': 
      return {
        ...state,
        colorPrimary: action.value
      }
    case 'fontColorPrimary':
      return {
        ...state,
        fontColorPrimary: action.value ? action.value : '#FFFFFF'
      }
    case 'canLang': 
      return {
        ...state,
        canLang: action.value
      }
		case 'open_new': 
			return {
				...state,
				open_new: action.value
			}
		case 'isCst':
			return {
				...state,
				isCst: action.value
			}
    case 'market':
      return {
        ...state,
				market: action.value
      }
    case 'is_market':
      return {
        ...state,
        is_market: action.value
      }
    case 'currency_data':
      return {
        ...state,
        currency_data: action.value
      }
    case 'countrie_data':
      return {
        ...state,
        countrie_data: action.value
      }
    case 'exrate':
      return {
        ...state,
        exrate: action.value
      }
		case 'distributorInfo':
			return {
				...state,
				distributorInfo: action.value
			}
    case 'imChatData':
      return {
        ...state,
        imChatData: action.value
      }
    case 'supplierOnline':
      return {
        ...state,
        supplierOnline: action.value
      }
    case 'unreadMsgCount':
      return {
        ...state,
        unreadMsgCount: action.value
      }
    case 'msgNoticeData': 
      return {
        ...state,
        msgNoticeData: action.value
      }
    case 'isOperate': 
      return {
        ...state,
        isOperate: action.value
      }
    case 'siteName': 
      return {
        ...state,
        siteName: action.value
      }
    case 'hasFreeVin':
      return {
        ...state,
        hasFreeVin: action.value
      }
    case 'cartPrice':
      return {
        ...state,
        cartPrice: action.value
      }
    case 'isVisitor':
      return {
        ...state,
        isVisitor: action.value
      }
    case 'shop_discount':
      return {
        ...state,
        shop_discount: action.value
      }
    case 'searchHistory':
      return {
        ...state,
        searchHistory: action.value
      }
    case 'detailConfig':
      return {
        ...state,
        detailConfig: action.value
      }
    case 'isGetFreeCjh':
      return {
        ...state,
        isGetFreeCjh: action.value
      }
    case 'freeCjhList':
      return {
        ...state,
        freeCjhList: action.value
      }
    case 'homeUrl':
      return {
        ...state,
        homeUrl: action.value
      }
    case 'companyInfo':
      return {
        ...state,
        companyInfo: action.value
      }
    case 'brandList': 
      return {
        ...state,
        brandList: action.value
      }
    case 'heightKey':
      return {
        ...state,
        heightKey: action.value
      }
    case 'inventoryParams':
      return {
        ...state,
        inventoryParams: action.value
      }
    case 'showOe':
      return {
        ...state,
        showOe: action.value
      }
    case 'sxSetData': 
      return {
        ...state,
        sxSetData: action.value
      }
    case 'supportData':
      return {
        ...state,
        supportData: action.value
      }
    case 'requireNum':
      return {
        ...state,
        requireNum: action.value
      }
    default:
      return state
  }
}
let runLayui = true
let online = false
let activeItem: any = {}
let companyData: any = {}
const Main: React.FC<any> = (props) => {
  const intl = useIntl()
  // const [api, contextHolder] = notification.useNotification();
  const imChatData = JSON.parse(localStorage.getItem('imChatData') || '{}')
  const navigate = useNavigate()
  const [commonStore, setCommonStore] = useReducer(reducer, {
    userInfo: {},
    areaOptions: [],
    pageType: localStorage.getItem("style") || '2',
    headerInfo: {
      pop: intl.formatMessage({id: '专注精品配件，竭诚为您服务！'}),
      model_checked: true,
      dropdown_checked: true
    },
    logo: '',
    epc_page_logo: '',
    epc_barnds: {},
    isWomala: false,
    webData: {},
    host: '',
    crumb: JSON.parse(window.sessionStorage.getItem('crumb') || '[]'),
    vinData: {},
    colorPrimary: localStorage.getItem("colorPrimary") || '#434343',
    fontColorPrimary: localStorage.getItem('fontColorPrimary') || '#FFFFFF',
    canLang: [],
		open_new: '1',
		isCst: 0,
    market: 1,
    is_market: 0,
    currency_data: {
      code: "CNY",
      name: intl.formatMessage({id: '人民币'}),
      unit: "￥"
    },
    countrie_data: {
      code: "CNY",
      unit: "￥"
    },
    exrate: 1,
		distributorInfo: {},
    imChatData: {
      appKey: imChatData.appKey,
      account: imChatData.account,
      token: imChatData.token
    },
    supplierOnline: [],
    unreadMsgCount: 0,
    msgNoticeData: {},
    isOperate: false,
    siteName: intl.formatMessage({id: '商城'}),
    hasFreeVin: false,
    cartPrice: 0,
    shop_discount: 0,
    searchHistory: [],
    detailConfig: ['oe', 'model', 'detail', 'after', 'evaluate', 'browsing', 'doc'],
    freeCjhList: [],
    isGetFreeCjh: false,
    homeUrl: '',
    companyInfo: {},
    brandList: [],
    heightKey: 1,
    inventoryParams: {
      stock_show: 0,
      price_show: 1
    },
    showOe: 1,
    sxSetData: [],
    supportData: {
      show_technical_support: 1,
      support_auth_login: 1
    },
    requireNum: 0
  })
  const { pageType, colorPrimary, heightKey } = commonStore

  const { pathname } = useLocation()
  const [ searchParams, setSearchParams ] = useSearchParams()
  const [ uid, setUid ] = useState<string>('')

  let _nim = useRef<any>(null)

  let vinkey = searchParams.get('vinkey') || ""

  const token = localStorage.getItem("token") || ""
  let other = ['/class', '/vin', '/code', '/carsearch/list', '/morepage']
  useEffect(() => {
    let host = window.location.host
    setCommonStore({ value: host, type: 'host' })
    if(host.includes('womala')) {
      setCommonStore({ value: true, type: 'isWomala' })
    }
    getSysiting()
    getIsInventoryParams()
    // getHomeData()
    getIsCst()
    getShowOe()
    getBrandList()
    if(token) {
      // getUserInfo()
			getDistributorInfo()
      getExquireNum()
      
    }
    fetch('https://xqpstatics.007vin.com/pca.json')
      .then(response => response.json())
      .then(data => {
        setCommonStore({value: data, type: 'areaOptions'})
      })
  },[])
  useEffect(() => {
    if(commonStore.currency_data && commonStore.currency_data.code && commonStore.countrie_data && commonStore.countrie_data.code) {
      if(commonStore.currency_data.code !== commonStore.countrie_data.code) {
        getExchangeRate()
      }
    }
  }, [commonStore.currency_data, commonStore.countrie_data])
  // useEffect(() => {
  //   if(token && uid) {
  //     getIm2(uid)
  //   }
  // }, [uid])
  useEffect(() => {
    console.log('pathname:', pathname)
    if(pageType === '10' && (pathname === '/' || !pathname) && commonStore.host) {
      getNavgation()
    } 
  }, [pageType, pathname, commonStore.host])
  const getNavgation = () => {
    let domain = window.location.host
    accountApi.getNavgationNew({ domain: commonStore.host || domain }).then((res: any) => {
      if(res.code === 1) {
        let navData = res.data
        let _allNav: any[] = []
        let cjhIndex = navData.findIndex((ele: any) => ele.path === '/cjh')
        let cjhItem = cjhIndex > -1 ? navData[cjhIndex] : {}
        let oeIndex = navData.findIndex((ele: any) => ele.path === '/oe')
        let oeItem = oeIndex > -1 ? navData[oeIndex] : {}
        navData.forEach((ele: any) => {
          if((ele.path === '/vin' || ele.path === '/cjh' || ele.path === '/carsearch') && ele.is_check === 1) {
            let index = _allNav.findIndex((el: any) => el.path === '/cjh')
            if(index === -1) {
              _allNav.push({
                path: '/cjh',
                is_add: 0,
                is_check: 1,
                name: cjhItem.name ? cjhItem.name : intl.formatMessage({id: '车架号查询'}),
                icon: ''
              })
            }
          }else if((ele.path === '/code' || ele.path === '/oe') && ele.is_check === 1) {
            let index = _allNav.findIndex((el: any) => el.path === '/oe')
            if(index === -1) {
              _allNav.push({
                path: '/oe',
                is_add: 0,
                is_check: 1,
                name: oeItem.name ? oeItem.name : intl.formatMessage({id: '零件号查询'}),
                icon: 'icon-lingjianchaxun'
              })
            }
          }else if(ele.is_add && ele.is_check) {
            ele.path = `/morepage/${ele.code}`
            _allNav.push(ele)
          }else if(ele.is_check) {
            if(ele.path === '/epc') {
              ele.icon = 'icon-EPCchaxun'
            }else if(ele.path === '/enquery') {
              ele.icon = 'icon-fabuxunjia'
            }
            _allNav.push(ele)
          }
        })
        let _standardNav = _allNav.filter((item: any, index: number) => index === 0 || (!item.is_add && item.is_check && item.path !== '/engine'))
        let _moreNav = _allNav.filter((item: any, index: number) => {
          if(item.is_add && item.is_check && index !== 0) {
            item.path = `/morepage/${item.code}`
            return true
          }
        })
        let filterStdNav = _standardNav
        if(filterStdNav.length < 4) {
          let lastIndexLen = 4 - filterStdNav.length
          let otherStandardNav = _moreNav.slice(0, lastIndexLen)
          _standardNav = [..._standardNav, ...otherStandardNav]
          _moreNav = _moreNav.slice(lastIndexLen)
        }
        let _homeUrl = _allNav[0] && _allNav[0].path ? _allNav[0].path : ''
        // console.log("homeUrl:", _homeUrl)
        setCommonStore({
          type: 'homeUrl',
          value: _homeUrl
        })
      }
    })
  }
  const getExquireNum = () => {
    accountApi.getRequireList({
      page: 1,
      size: 10,
      keyword: ''
    }).then((res: any) => {
      if(res.code === 1) {
        let total = res.data && res.data.total ? res.data.total : 0
        setCommonStore({
          type: 'requireNum',
          value: total
        })
      }
    })
  }
  const getIsInventoryParams = () => {
		commonApi.getInventoryParams().then((res: any) => {
			if(res.code === 1) {
				let _data = res.data ? res.data : {}
				setCommonStore({
          type: 'inventoryParams',
          value: _data
        })
			}
		})
	}
	const getDistributorInfo = () => {
		accountApi.getDistributorInfo().then((res: any) => {
			if(res.code === 1) {
				setCommonStore({value: res.data, type: 'distributorInfo'})
			}
		})
	}
	
  const getShowOe = () => {
    accountApi.getShowOe().then((res: any) => {
      if(res.code === 1) {
        setCommonStore({value: res.data, type: 'showOe'})
      }
    })
  }
	const getIsCst = () => {
	  accountApi.getIsCst().then((res: any) => {
	    if(res.code === 1) {
				setCommonStore({value: res.data.is_cst, type: 'isCst'})
        let _market = res.data && res.data.market ? res.data.market : 1
        let currency_data = res.data && res.data.currency_data && res.data.currency_data.code ? res.data.currency_data : {
          code: "CNY",
          name: intl.formatMessage({id: '人民币'}),
          unit: "￥"
        }
        let countrie_data = res.data && res.data.user_currency && res.data.user_currency.countrie_monetary_en ? {
          code: res.data.user_currency.countrie_monetary_en,
          unit: res.data.user_currency.countrie_symbol ? res.data.user_currency.countrie_symbol : ''
        } : (res.data && res.data.currency_data && res.data.currency_data.code ? {
          code: res.data.currency_data.code,
          unit: res.data.currency_data.unit ? res.data.currency_data.unit : ''
        } : {
          code: 'CNY',
          unit: "￥"
        })
        currency_data.countryCode = res.data.countryCode || 'CN'
        let shop_discount = res.data && res.data.shop_discount ? res.data.shop_discount : 0
        setCommonStore({
          type: 'shop_discount',
          value: shop_discount
        })
        setCommonStore({value: _market, type: 'market'})
        setCommonStore({
          value: currency_data,
          type: 'currency_data'
        })
        setCommonStore({
          value: countrie_data,
          type: 'countrie_data'
        })
        setCommonStore({
          type: 'supportData',
          value: {
            show_technical_support: res.data && (typeof res.data.show_technical_support === 'number') ? res.data.show_technical_support : 1,
            support_auth_login: res.data && (typeof res.data.support_auth_login === 'number') ? res.data.support_auth_login : 1
          }
        })
	    }
	  })
	}
  const getExchangeRate = () => {
    accountApi.getCurrencyRate({
      from_currency: commonStore.currency_data.code,
      to_currency: commonStore.countrie_data.code
    }).then((res: any) => {
      if(res.code === 1) {
        let _exrate = res.data
        let isNumber = isNaN(parseFloat(_exrate)) ? false : true
        if(typeof _exrate === 'string' && isNumber) {
          setCommonStore({value: parseFloat(_exrate), type: 'exrate'})
        }else if(typeof _exrate === 'number') {
          setCommonStore({value: _exrate, type: 'exrate'})
        }
      }
    })
  }
  const getBrandList = () => {
    accountApi.getSelectBrandList().then((res: any) => {
      if(res.code === 1) {
        let _brandList: any = []
        res.data.cars_brands.all_brands.brands.forEach((code: any) => {
          code.brands.forEach((item: any) => {
            _brandList.push({
              ...item,
              img: item.brand_img
            })
          })
        })
        setCommonStore({
          type: 'brandList',
          value: _brandList
        })
      }
    })
  }
	const getHomeData = () => {
    let lang = localStorage.getItem('lang') || undefined
    accountApi.getHomeDataThree({ 
      domain: commonStore.host || window.location.host,
      lang
    }).then((res: any) => {
      if(res.code === 1) {
        let dataVin = res.data && res.data.vin ? res.data.vin : []
        let contract2 = res.data && res.data.contract2 ? res.data.contract2 : {}
        if(lang) {
          let item = contract2[lang] ? contract2[lang] : {}
          setCommonStore({ value: item, type: 'webData' })
        }
        setCommonStore({ value: dataVin.length ? true : false, type: 'hasFreeVin'})
        setCommonStore({ value: res.data.name, type: 'siteName' })
        setCommonStore({
          value: dataVin,
          type: 'freeCjhList'
        })
      }
    })
  }

  function isImageCached(imgUrl: any) {
    return new Promise((resolve) => {
      const img = new Image();

      // 缓存的图片会立即触发onload，所以先设置一个极短的定时器检测状态
      const timer = setTimeout(() => {
        // 如果定时器先执行，说明图片还在加载（未缓存）
        resolve(false);
      }, 100); // 10ms是经验值，可根据实际情况调整

      // 图片加载完成回调
      img.onload = () => {
        clearTimeout(timer);
        // 能走到这里说明图片加载完成，且耗时<10ms，判定为已缓存
        resolve(true);
      };

      // 图片加载失败（如404），判定为未缓存
      img.onerror = () => {
        clearTimeout(timer);
        resolve(false);
      };

      // 关键：设置src触发加载（缓存的图片不会发起网络请求）
      img.src = imgUrl;
    });
  }

  // 预加载函数
  function preloadImage(url: any) {
    const img = new Image();
    img.src = url;
    // 图片加载完成后，会自动存入浏览器缓存
    img.onload = () => {
      console.log(`图片 ${url} 预加载完成并缓存`);
    };
  }

  // 用法示例
  async function checkCache(url: any) {
    const isCached = await isImageCached(url);
    if (isCached) {
      console.log('图片已缓存 ✅');
    } else {
      console.log('图片未缓存 ❌，开始预加载...');
      // 这里可以调用之前的预加载函数
      preloadImage(url);
    }
  }
  const preloadKonowImage = () => {
    let imgArr = [
      'https://xqpcdns.007vin.com/1767696929782.截屏2025-12-24 14.49.46 1.png',
      'https://xqpcdns.007vin.com/1767696970346.截屏2025-12-24 14.48.39 1.png',
      'https://xqpcdns.007vin.com/1767697013499.截屏2025-12-24 14.49.31 1.png',
      'https://xqpcdns.007vin.com/1767697035897.截屏2025-12-24 14.48.51 1.png',
      'https://xqpcdns.007vin.com/1767697057389.截屏2025-12-24 14.49.06 1.png'
    ]
    imgArr.forEach((url) => checkCache(url))
  }
	
  const getSysiting = () => {
    let params = {
      lang: localStorage.getItem('lang') || undefined,
      domain: commonStore.host || window.location.host
    }
    accountApi.getSysiting(params).then((res: any) => {
      if(res.code === 1) {
        let localstyle = localStorage.getItem("style")
        if(!localstyle || (res.data.style !== localstyle)) {
          localStorage.setItem('style', res.data.style || '2')
          setCommonStore({ value: res.data.style || '2', type: 'pageType' })
          if(res.data.style === '10') {
            getSxSetData()
          }
          if(res.data.style === '8') preloadKonowImage()

          console.log("res.data.model_checked:", res.data.model_checked)
          if(res.data.style && res.data.style === '7') {
            setCommonStore({
              value: { 
                pop: res.data.title_pop ? res.data.title_pop : intl.formatMessage({id: '专注精品配件，竭诚为您服务！'}),
                model_checked: res.data.model_checked ? res.data.model_checked : false,
                dropdown_checked: res.data.dropdown_checked ? res.data.dropdown_checked : false
              },
              type: 'headerInfo'
            })
          }
        }else {
          if(res.data.style === '10') {
            getSxSetData()
          }
          if(res.data.style && res.data.style === '7') {
            setCommonStore({
              value: { 
                pop: res.data.title_pop ? res.data.title_pop : intl.formatMessage({id: '专注精品配件，竭诚为您服务！'}),
                model_checked: res.data.model_checked ? res.data.model_checked : false,
                dropdown_checked: res.data.dropdown_checked ? res.data.dropdown_checked : false
              },
              type: 'headerInfo'
            })
          }
          if(res.data.style === '8') preloadKonowImage()
        }
        let detail_config = res.data && res.data.detail_config ? res.data.detail_config : ['oe', 'model', 'detail', 'after', 'evaluate', 'browsing', 'doc']
        setCommonStore({
          type: 'detailConfig',
          value: detail_config
        })
        setCommonStore({
          type: 'isVisitor',
          value: res.data.is_visitor ? res.data.is_visitor : 0
        })
        setCommonStore({
          type: 'is_market',
          value: res.data && res.data.is_market ? res.data.is_market : 0
        })
        if(res.data && res.data.is_visitor) {
          if(!localStorage.getItem('token') || localStorage.getItem('tourist_user')) {
            accountApi.freeLogin().then((res1: any) => {
              if(res1.code === 1 && (!localStorage.getItem('token') || localStorage.getItem('tourist_user'))) {
                localStorage.setItem('tourist_user', '1')
                localStorage.setItem('token', res1.data.token)
                localStorage.setItem('ycid', res1.data.yc_id)
                localStorage.setItem("openid", res1.data.open_id)
                getUserInfo()
              }
            })
          }else {
            getUserInfo()
          }
        }else {
          if(localStorage.getItem('tourist_user')) {
            localStorage.removeItem('tourist_user')
            localStorage.removeItem('token')
            localStorage.removeItem('ycid')
            localStorage.removeItem('openid')
            localStorage.removeItem('uid')
            setCommonStore({
              type: 'userInfo',
              value: {}
            })
          }
          if(localStorage.getItem('token') && !localStorage.getItem('tourist_user')) {
            getUserInfo()
          }
        }
        setCommonStore({ value: res.data.logo, type: 'logo' })
        setCommonStore({ value: res.data.epc_page_logo, type: 'epc_page_logo' })
        document.title = res.data.name || ''
        if(res.data.icon) {
          let icon = document.createElement("link")
          icon.rel = 'icon'
          icon.href = res.data.icon
          document.getElementsByTagName('head')[0].appendChild(icon)
        }
				setCommonStore({ value: res.data.open_new ? res.data.open_new : '1', type: 'open_new' })
        // setCommonStore({ value: res.data, type: 'webData' })
        setCommonStore({ value: res.data.languages, type: 'canLang' })
        
        setCommonStore({ value: res.data.color || '#434343', type: 'colorPrimary' })
        setCommonStore({ value: res.data.font_color || '#FFFFFF', type: 'fontColorPrimary'})
        localStorage.setItem("colorPrimary", res.data.color || '#434343')
        localStorage.setItem("fontColorPrimary", res.data.font_color)
        // document.getElementsByTagName("body")[0].style.setProperty('--test', '#898734')
      }
    })
  }
  const getSxSetData = () => {
    accountApi.getSxSetData().then((res: any) => {
      if(res.code === 1) {
        setCommonStore({
          value: res.data || {},
          type: 'sxSetData'
        })
      }
    })
  }
  const getUserInfo = () => {
    accountApi.getUserInfo().then((res: any) => {
      if(res.code === 1) {
        res.data.company = res.data.reg_company_name
        setCommonStore({value: res.data, type: 'userInfo'})
        // getIm2(res.data.uid)
        setUid(res.data.uid)
        localStorage.setItem('uid', res.data.uid)
        if(!localStorage.getItem('tourist_user')) {
          getIm2(res.data.uid)
        }
        getCompanyInfo(res.data)
      }
    })
  }

  const getCompanyInfo = (userInfo: any) => {
    orderApi.getCompanyInfo({
      repair_shop_id: userInfo && userInfo.repair_shop_id ? userInfo.repair_shop_id : '',
    }).then((res: any) => {
      if(res.code === 1) {
        setCommonStore({
          type: 'companyInfo',
          value: res.data
        })
      }
    })
  }
	
  /* const openNotification = (data: any) => {
		if(data.notice_type === 'refund') {
		  const key = `open${Date.now()}`;
		  const btn = (
		    <Button 
					type="primary" 
					onClick={() => {
						api.destroy();
						if(pathname === '/mine/aftersales/detail') {
							window.location.reload()
						}else {
							navigate(`/mine/aftersales/detail?merchant_id=${data.merchant_id}&inquiry_id=${data.inquiry_id}&refund_id=${data.refund_id}`)
						}
					}}>
					{intl.formatMessage({ id: '查看详情' })}
				</Button>
		  );
		  let refund_status = data.refund_status
		  let message;
		  if(refund_status === 1) {
		    message = intl.formatMessage({ id: '售后订单商家已同意！' })
		  }else {
		    message = intl.formatMessage({ id: '售后订单商家已拒绝！' })
		  }
		  api.open({
		    message: message,
		    duration: null,
		    description:(
		      <div>
		        <div className="mt10">
							{intl.formatMessage({ id: '创建时间' })}:{data.create_time}
						</div>
						<div className="mt10">
              {intl.formatMessage({ id: '处理时间' })}:{data.send_time}
						</div>
		      </div>
		    ),
		    btn,
		    key,
		    // onClose: close,
		  });
		}
    if(data.notice_type === 'order_quote_finished' || data.notice_type === 'order_wait_send') {
      const key = `open${Date.now()}`;
      const btn = (
        <Button type="primary" onClick={
					() => {
						if(window.location.pathname === '/mine/order/detail') {
						  window.location.reload()
						}else {
						  api.destroy(); 
							navigate(`/mine/order/detail?merchant_id=${data.merchant_id}&inquiry_id=${data.enquiry_info.enquiry_id}`)
						}
					}
				}
				>{intl.formatMessage({ id: '查看详情' })}</Button>
      );
      let inquiry_status = data.inquiry_status
      let car_info = data.car_info 
      let message;
      if(inquiry_status === 5) {
        message = intl.formatMessage({ id: '订单已报价，请尽快处理！' })
      }else {
        message = intl.formatMessage({ id: '订单已发货，请注意查收！' })
      }
      api.open({
        message: message,
        duration: null,
        description:(
          <div>
            {
              car_info ? (
                <div className="flex-s-c">
                  {car_info.brand_logo ? <img style={{ height: 20, border: '1px solid #f6f6f6' }} src={car_info.brand_logo} /> : ''}
                  {car_info.market_name}
                </div>
              ): null
            }
            <div className="mt20">{intl.formatMessage({ id: '创建时间' })}：{data.order_create_time}</div>
            {
              inquiry_status === 5 ? (
                <div className="mt10">{intl.formatMessage({ id: '报价时间' })}：{data.quote_time}</div>
              ): inquiry_status === 8 ? (
                <div className="mt10">{intl.formatMessage({ id: '发货时间' })}：{data.send_time}</div>
              ): null
            }
          </div>
        ),
        btn,
        key,
        // onClose: close,
      });
    }
    if(data.notice_type === 'user_verify') {
      const key = `open${Date.now()}`;
      const btn = (
        <Button type="primary" onClick={() => {
          if(window.location.pathname === '/mine/company') {
            window.location.reload()
          }else {
            api.destroy(); navigate(`/mine/company`)
          }
        }
        }>{intl.formatMessage({ id: '前往处理' })}</Button>
      );
      let phone = data.phone
      let _phone = phone.slice(-4)
      let message = `尾号${_phone}用户，提交了认证审核！`
      let time = data.create_time
      api.open({
        message: intl.formatMessage({ id: '审核单' }),
        duration: null,
        description:(
          <div>
            <div style={{color: '#333333', fontSize: 14}}>{message}</div>
            <div style={{marginTop: 8, color: '#888888', fontSize: 14}}>{time}</div>
          </div>
        ),
        btn,
        key,
        // onClose: close,
      });
    }
  }; */

  /* const getIm = (uid: string) => {
    let params = {
      uid
    }
    accountApi.getIm(params).then((res: any) => {
      if(res.code === 1) {
        let itemData = res.data
        setCommonStore({
          type: 'imChatData',
          value: {
            appKey: itemData.app_key,
            account: itemData.accid,
            token: itemData.token,
          }
        })
        let _window: any = window
        _nim.current = _window.SDK.NIM.getInstance({
          appKey: itemData.app_key,
          account: itemData.accid,
          token: itemData.token,
          onsessions: function(sessions: any){
            console.log('sessions:', sessions)
          },
          onconnect: function () {
            console.log('SDK 连接成功')
            if(runLayui){
              layui()
              runLayui = false
            }
            online = true
          },
          ondisconnect: function(obj: any) {
            console.log('SDK 连接断开', obj)
            online = false
            if(obj.code !== "kicked"){
              setTimeout(()=>{
                console.log('重新连接1')
                getIm(uid)
              }, 1000 * 5)
            }else {
              // obj.code === 417 || 302
            }
          },
          onerror: function(error: any) {

            console.log('SDK 连接失败', error)
            setTimeout(()=>{
              console.log('重新连接2')
              getIm(uid)
            }, 1000 * 5)
          },
          onmsg: function(msg: any) {
            console.log('onmsg msg:', msg)
            console.log('msg.text:', JSON.parse(msg.text))
            let msgTextObj = msg.text ? JSON.parse(msg.text) : {}
            if(msg.from === itemData.accid) { 
              let _window: any = window
              let local = _window.layui.data('layim')[itemData.accid] || {};
              if(local && local.chatlog && local.chatlog['friend' + msg.to].length){
                let toUser = local.chatlog['friend' + msg.to][0]
                if(msg.type === 'image'){
                  msg.text = 'img['+ msg.file.url +']'
                }
                local.chatlog['friend' + msg.to].push({
                  username: toUser.username,
                  avatar: toUser.avatar,
                  id: toUser.id,
                  type: toUser.type,
                  content: msg.text,
                  timestamp: msg.time,
                  mine: true
                })
                console.info('=======123=======')
              }
              _window.layui.data('layim', {
                key: itemData.accid,
                value: local
              });
              _window.layim.syncRecord()
            }
            if((msg.type === "text" || msg.type === 'image') && msg.from !== itemData.accid){
              let _window: any = window
              let content = {}
              try {
                content = JSON.parse(msg.text)
              }catch(err){

              }
              let isFromOrder = msgTextObj.notice_type === 'refund' || msgTextObj.notice_type === 'order_quote_finished' || msgTextObj.notice_type === 'order_wait_send' || msgTextObj.notice_type === 'user_verify' ? true : false
              if(isFromOrder) {
                openNotification(JSON.parse(msg.text))
              }else {
                _nim.current.subscribeEvent({
                  type: 1,
                  accounts: [msg.from],
                  subscribeTime: 70,
                  sync: true,
                  done: (error: any, obj: any)=>{
                    console.log('取消订阅事件' + (!error?'成功':'失败'), error, obj);
                  }
                });
                _nim.current.getUser({
                  account: msg.from,
                  done: (error: any, obj: any)=>{
                    console.log('取消订阅事件' + (!error?'成功':'失败'), error, obj);
                    let param = {
                      username: msg.fromNick,
                      id: msg.from,
                      avatar: '/webshop/layim/images/sellerphone.png',
                      type: "friend",
                      content: msg.text,
                      timestamp: msg.time
                    }
                    if(!error && obj.avatar){
                      param.avatar = obj.avatar
                    }
                    if(msg.type === 'image'){
                      param.content = 'img['+ msg.file.url +']'
                    }
                    _window.layim.getMessage(param)
                    _window.jQuery('.layim-list-history li').each(function(index: number, element: any){
                      let _this: any = element
                      if(('friend' + param.id) == _window.jQuery(_this).attr('data-index') && (('friend'+ _window.activeImWindowId) != _window.jQuery(_this).attr('data-index') || _window.activeImWindowStatus)){
                        _window.jQuery('#imTips').addClass('im-tips-ani')
                        if(!_window.jQuery(_this).find('em')[0]){
                          let em = _window.jQuery("<em>1</em>")
                          _window.jQuery(_this).append(em)
                        }else {
                          let i = parseInt(_window.jQuery(_this).find('em').text())
                          i++
                          if(i > 99){
                            i = 99
                          }
                          _window.jQuery(_this).find('em').text(i)
                        }
                      }
                    })
                  }
                })
              }
            }
          },
          onRoamingMsgs: function(obj: any) {
            console.log('收到漫游消息', obj);
          },
          onofflinemsgs: function(obj: any) {
            console.log('收到离线消息', obj);
            let _window: any = window
            obj.msgs.forEach((item: any)=>{
              let msgTextObj = item.text ? JSON.parse(item.text) : {}
              if(item.from === itemData.accid){
                let local = _window.layui.data('layim')[itemData.accid] || {};
                // local.history = {}
                if(local && local.chatlog && local.chatlog['friend' + item.to].length){
                  let toUser = local.chatlog['friend' + item.to][0]
                  if(item.type === 'image'){
                    item.text = 'img['+ item.file.url +']'
                  }
                  local.chatlog['friend' + item.to].push({
                    username: toUser.username,
                    avatar: toUser.avatar,
                    id: toUser.id,
                    type: toUser.type,
                    content: item.text,
                    timestamp: item.time,
                    mine: true
                  })
                }
                _window.layui.data('layim', {
                  key: itemData.accid
                  ,value: local
                });
                _window.layim.syncRecord && _window.layim.syncRecord()
              }
              if((item.type === "text" || item.type === 'image') && item.from !== itemData.accid){
                let content = {}
                try {
                  content = JSON.parse(item.text)
                }catch(err){}
                let isFromOrder = msgTextObj.notice_type === 'refund' || msgTextObj.notice_type === 'order_quote_finished' || msgTextObj.notice_type === 'order_wait_send' || msgTextObj.notice_type === 'user_verify' ? true : false
                if(isFromOrder) {
                  openNotification(JSON.parse(item.text))
                }else {
                  _nim.current.getUser({
                    account: item.from,
                    done: (error: any, obj: any)=>{
                      console.log('取消订阅事件' + (!error?'成功':'失败'), error, obj);
                      let param = {
                        username: item.fromNick,
                        id: item.from,
                        avatar: '/webshop/layim/images/sellerphone.png',
                        type: "friend",
                        content: item.text,
                        timestamp: item.time
                      }
                      if(!error && obj.avatar){
                        param.avatar = obj.avatar
                      }
                      if(item.type === 'image'){
                        param.content = 'img['+ item.file.url +']'
                      }
                      _window.layim.getMessage(param)
                      _window.jQuery('.layim-list-history li').each(function(index: number, element: any){
                        let _this: any = element
                        if(('friend'+param.id) == _window.jQuery(_this).attr('data-index') && (('friend'+ _window.activeImWindowId) != _window.jQuery(_this).attr('data-index') || _window.activeImWindowStatus)){
                          _window.jQuery('#imTips').addClass('im-tips-ani')
                          if(!_window.jQuery(_this).find('em')[0]){
                            let em = _window.jQuery("<em>1</em>")
                            _window.jQuery(_this).append(em)
                          }else {
                            let i = parseInt(_window.jQuery(_this).find('em').text())
                            i++
                            if(i > 99){
                              i = 99
                            }
                            _window.jQuery(_this).find('em').text(i)
                          }
                        }
                      })
                    }
                  })
                  
                }
              }
              
            })
          },
          onpushevents: function(param: any) {
            console.log('订阅事件', param)
            let _window: any = window
            if(param && param.msgEvents){
              let _online: any[] = []
              param.msgEvents.forEach((item: any)=>{
                let serverConfig = JSON.parse(item.serverConfig)
                if(serverConfig && serverConfig.online && serverConfig.online.length){
                  _online.push(item.account)
                  _window.jQuery('.layim-list-history li').each(function(index: number, element: any){
                    let _this: any = element
                    if(('friend'+item.account) == _window.jQuery(_this).attr('data-index')){
                      _window.jQuery(_this).find('p').html('<i></i>' + '在线')
                    }
                  })
                }
              })
              setCommonStore({
                type: 'supplierOnline',
                value: _online
              })
            }
          }
        })
        
      }
    })
  }
  const layui = () => {
    let _window: any = window
    let layui: any = _window.layui
    let userInfo = commonStore.userInfo
    let companyDataTips: any = {}
    let statusList = []
    let companyAcitveId = ''
    
    layui.use('layim', function(layim: any){
      _window.layim = layim

      var wsSend = (data: any) => {
        if(data.content.indexOf('img[') !== 0){
          _nim.current.sendText({
            scene: 'p2p',
            to: data.toId,
            text: data.content,
            fromNick: data.username,
            done: function(error: any, msg: any) {
              console.info(msg)
            }
          })
        }
        
      }
      
      let accid = commonStore.imChatData && commonStore.imChatData.account ? commonStore.imChatData.account : ''
      //基础配置
      layim.config({
        init: {
          mine: {
            "username": userInfo.wechat_nick || userInfo.phone //我的昵称
            ,"id": accid //我的ID
            ,"status": "online" //在线状态 online：在线、hide：隐身
            ,"remark": "" //我的签名
            ,"avatar": userInfo.avatar || '/webshop/layim/images/phone.png' //我的头像
            ,'userInfo': userInfo
          }
          ,friend: []
          ,group: []
        },
        isfriend: true,
        isgroup: false,
        title: '在线沟通',
        notice: true //是否开启桌面消息提醒，默认false
        // ,chatLog: layui.cache.dir + 'css/modules/layim/html/chatlog.html' 
        // ,chatLog: process.env.NODE_ENV === 'development' ? '/chatlog.html' : '/chat/log'
      });
    
      let local = _window.layui.data('layim')[accid]
      local = local || {}
      if(local.history){
        let idArr = []
        for(let key in local.history){
          idArr.push(local.history[key].id)
        }
        _nim.current.subscribeEvent({
          type: 1,
          accounts: idArr,
          subscribeTime: 70,
          sync: true,
          done: (error: any, obj: any)=>{
            console.log('取消订阅事件' + (!error?'成功':'失败'), error, obj);
          }
        });
      }
      console.info('local=======')
      console.info(local)

      //监听在线状态的切换事件
      layim.on('online', function(data: any){
        //console.log(data);
      });
      
      //监听签名修改
      layim.on('sign', function(value: any){
        //console.log(value);
      });
    
      
      //监听layim建立就绪
      // layim.on('ready', function(res){
      //   console.info(res)
      // });
    
      //监听发送消息
      layim.on('sendMessage', function(data: any){
        console.info(data)
        if(online){
          wsSend({
            username: data.mine.username,
            id: data.mine.id,
            toId: data.to.id,
            type: data.to.type,
            content: data.mine.content,
            avatar: data.mine.avatar,
            tel: data.mine.userInfo.phone || '暂无'
          })
        }else {
          antdMessage.warning('消息发送失败，请稍后重试！')
        }
      });
    
      //监听查看群员
      layim.on('members', function(data: any){
        console.log('members:', data);
      });
      

      //监听聊天窗口的切换
      layim.on('chatChange', function(res: any){
        let type = res.data.type;
        console.info('res=======')
        activeItem = res
        if(type === 'friend'){
          companyAcitveId = res.data.id

          _window.jQuery('.layim-list-history li').each(function(index: number, element: any){
            let _this: any = element
            if(('friend'+res.data.id) == _window.jQuery(_this).attr('data-index')){
              _window.jQuery('#imTips').removeClass('im-tips-ani')
              if(_window.jQuery(_this).find('em')[0]){
                _window.jQuery(_this).find('em').remove()
              }
            }
          })
          console.info(res.data)

          companyData = res.data || {}
          let info = ''
          
          
          if(res.data.companyData){
            companyDataTips[res.data.id] = res.data
          }
          if(commonStore.supplierOnline.indexOf(companyAcitveId) !== -1 ){
            _window.jQuery('.layim-chat-status-icon').html('<i></i>' + '在线')
          }

          let imContact = JSON.parse(window.localStorage.getItem("imContact") || '{}')
          
          if(imContact[res.data.id]){
            let contact = imContact[res.data.id]
            info ='<p class="copyOn" title="'+ contact.phone +'">电话: ' + contact.phone + '<span class="font_family icon-copy im-copy" />' +'</p>'
            if(contact.wechat){
              info += ('<p class="copyOn" title="'+ contact.qq +'">' + 'Q Q: ' + contact.qq + '<span class="font_family icon-copy im-copy" />' + '</p>')
            }
            if(contact.qq){
              info += ('<p class="copyOn" title="'+ contact.wechat +'">' + '微信: ' + contact.wechat + '<span class="font_family icon-copy im-copy" />' + '</p>')
            }
            layim.setChatStatus(info);
          }else {
            commonApi.getImUserInfo({yc_id: res.data.id}).then((result: any)=>{
              if(result.code === 1 && result.data.contact){
                let contact = result.data.contact
                imContact[res.data.id] = contact
                info ='<p class="copyOn" title="'+ contact.phone +'">电话: ' + contact.phone + '<span class="font_family icon-copy im-copy" />' +'</p>'
                if(contact.wechat){
                  info += ('<p class="copyOn" title="'+ contact.qq +'">' + 'Q Q: ' + contact.qq + '<span class="font_family icon-copy im-copy" />' + '</p>')
                }
                if(contact.qq){
                  info += ('<p class="copyOn" title="'+ contact.wechat +'">' + '微信: ' + contact.wechat + '<span class="font_family icon-copy im-copy" />' + '</p>')
                }
                localStorage.setItem('imContact', JSON.stringify(imContact));
              }
              layim.setChatStatus(info);
            })
          }
          

          
        }
      })
    })
    function fileReaderupdateImg(file: any){
      let _window: any = window
      let reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = (e: any) => {
        let img: any = new Image()
        img.src = e.target.result
        img.onload = () => {
          let data = compress(img)
          let blob = dataURItoBlob(data)
          let formData = new FormData()
          formData.append('img', blob)
          console.info(blob)
          _window.jQuery('#updateImgTips').show()
          _nim.current.previewFile({
            type: 'image',
            blob: blob,
            done: function(error: any, file: any) {
              _window.jQuery('#updateImgTips').hide()
              if(!error){
                _window.layim.chat('send', 'img['+ file.url +']')
                if(activeItem.data.id){
                  _nim.current.sendFile({
                    scene: 'p2p',
                    to: activeItem.data.id,
                    blob: blob,
                    type: 'image',
                    done: function (error: any, msg: any) {
                      console.info(msg)
                    }
                  })
                }
              }
            }
          })
          
        }
      }

    }
    
    _window.jQuery('.updateImg').live('paste', function(event: any){
      let clipboardData = event.originalEvent.clipboardData
      if ( !(clipboardData && clipboardData.items) ) {
        return;
      }
      for (let i = 0, len = clipboardData.items.length; i < len; i++) {
        let item = clipboardData.items[i];
        if (item.type.indexOf('image') !== -1) {
          let f = item.getAsFile();
          fileReaderupdateImg(f)
        }
      }
    })
    
    _window.jQuery('.updateImg').live('drop', function(event: any){
      event.preventDefault()
      let f = event.originalEvent.dataTransfer.files[0];
      if(f.type.indexOf('image') !== -1 ){
        fileReaderupdateImg(f)
      }
    })

    _window.jQuery('.copyOn').live('click', function(event: any){
      event.preventDefault()
      let _this: any = event.target
      copy(_window.$(_this).attr('title'))
    })
  }

  const compress = (img: any) => {
    let canvas = document.createElement('canvas')
    let ctx: any = canvas.getContext('2d')
    let width = img.width
    let height = img.height
    canvas.width = width
    canvas.height = height
    ctx.fillStyle = '#fff'
    ctx.fillRect(0, 0, canvas.width, canvas.height)
    ctx.drawImage(img, 0, 0, width, height)
    let ndata = canvas.toDataURL('image/jpeg', 0.5)
    return ndata
  }
  const dataURItoBlob = (base64Data: any) => {
    let byteString
    if (base64Data.split(',')[0].indexOf('base64') >= 0) {
      byteString = atob(base64Data.split(',')[1])
    } else {
      byteString = unescape(base64Data.split(',')[1])
    }
    let mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0]
    let ia = new Uint8Array(byteString.length)
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i)
    }
    return new Blob([ia], { type: mimeString })
  }
  const copy = (text: string) => {
    let oDiv = document.createElement('textarea')
    oDiv.value = text
    oDiv.innerHTML = text
    document.body.appendChild(oDiv)
    oDiv.select()
    document.execCommand("Copy")
    document.body.removeChild(oDiv)
    antdMessage.success('复制成功！')
  } */
  // 使用NIM  nim-web-sdk 网易云信9.x版本
  const getIm2 = async (uid: string) => {
    let params = {
      uid
    }
    let res = await accountApi.getIm(params)
    if(res.code === 1) {
      let itemData = res.data
      setCommonStore({
        type: 'imChatData',
        value: {
          appKey: itemData.app_key,
          account: itemData.accid,
          token: itemData.token,
        }
      })
      let imChatData = {
        appKey: itemData.app_key,
        account: itemData.accid,
        token: itemData.token,
      }
      localStorage.setItem('imChatData', JSON.stringify(imChatData))
      /* _nim.current = SDK.NIM.getInstance({
        debug: true,
        appKey: itemData.app_key,
        account: itemData.accid,
        token: itemData.token,
        onconnect: function () {
          console.log('SDK 连接成功')
        },
        ondisconnect: function(obj: any) {
          console.log('SDK 连接断开', obj)
          if(obj.code !== "kicked"){
            setTimeout(()=>{
              console.log('重新连接1')
              getIm2(uid)
            }, 1000 * 5)
          }else {
            // obj.code === 417 || 302
          }
        },
        onerror: function(error: any) {

          console.log('SDK 连接失败', error)
          setTimeout(()=>{
            console.log('重新连接2')
            getIm2(uid)
          }, 1000 * 5)
        },
        onmsg: function(msg: any) {
          console.log('onmsg msg:', msg)
          if(msg.from === itemData.accid) {
            console.log('msg.text:', JSON.parse(msg.text))
            let msgTextObj = msg.text ? JSON.parse(msg.text) : {}
            let isFromOrder = msgTextObj.notice_type === 'refund' || msgTextObj.notice_type === 'order_quote_finished' || msgTextObj.notice_type === 'order_wait_send' || msgTextObj.notice_type === 'user_verify' ? true : false
            if(isFromOrder) {
              openNotification(JSON.parse(msg.text))
            }
          }
        },
        onroamingmsgs: function(obj: any) {
          console.log('收到漫游消息', obj);
        },
        onofflinemsgs: function(obj: any) {
          console.log('收到离线消息', obj);
          obj.msgs.forEach((item: any)=>{
            if(item.from === itemData.accid) {
              let msgTextObj = item.text ? JSON.parse(item.text) : {}
              let isFromOrder = msgTextObj.notice_type === 'refund' || msgTextObj.notice_type === 'order_quote_finished' || msgTextObj.notice_type === 'order_wait_send' || msgTextObj.notice_type === 'user_verify' ? true : false
              if(isFromOrder) {
                openNotification(JSON.parse(item.text))
              }
            }
          })
        },
        onsysmsgunread: function(obj: any) {
          console.log('未读系统消息', obj)
          let total = obj.total
          setCommonStore({
            type: 'unreadMsgCount',
            value: total
          })
        }
      }) */
      
    }
  }

  const [curLanguage, setCurLanguage] = useState<"zh" | "en" | "ru" | "cht" | "tr" | "ara" | "pt" | "vie" | "fra" | "kor">('zh')
    // sdk版本
    const urlParams = new URLSearchParams(window.location.search)
    // 添加好友是否需要验证
    const [addFriendNeedVerify, setAddFriendNeedVerify] = useState<boolean>(false)
    //单聊消息是否显示已读未读
    const [p2pMsgReceiptVisible, setP2pMsgReceiptVisible] =
      useState<boolean>(true)
    //群聊消息是否显示已读未读
    const [teamMsgReceiptVisible, setTeamMsgReceiptVisible] =
      useState<boolean>(true)
    // 是否需要@消息
    const [needMention, setNeedMention] = useState<boolean>(true)
    // 是否开启群管理员功能
    const [teamManagerVisible, setTeamManagerVisible] = useState<boolean>(true)
    const languageMap = { zh, en, ru, cht, tr, ara, pt, vie, fra }
    // 初始化参数
    /* const initOptions = useMemo(() => {
      if(commonStore.imChatData.appKey) {
        return {
          appkey: commonStore.imChatData.appKey,
          account: commonStore.imChatData.account,
          token: commonStore.imChatData.token,
          lbsUrls: ['https://lbs.netease.im/lbs/webconf.jsp'],
          linkUrl: 'weblink.netease.im',
          needReconnect: true,
          reconnectionAttempts: 5,
        }
      }else {
        return {
          appkey: '',
          account: '',
          token: '',
          lbsUrls: ['https://lbs.netease.im/lbs/webconf.jsp'],
          linkUrl: 'weblink.netease.im',
          needReconnect: true,
          reconnectionAttempts: 5,
        }
      }
      
    }, [commonStore.imChatData.appKey, commonStore.imChatData.account, commonStore.imChatData.token]) */
    const nim = useMemo(() => {
      if(commonStore.imChatData.appKey) {
        const v2nim = V2NIM.getInstance({
          appkey: commonStore.imChatData.appKey,
          debugLevel: "debug",
          apiVersion: "v2",
          enableV2CloudConversation: sessionStorage.getItem("enableV2CloudConversation") ? sessionStorage.getItem("enableV2CloudConversation") == "true" : false,
        });
        return v2nim;
      }
    }, [commonStore.imChatData.appKey]);
    // 登录
    useEffect(() => {
      if (
        commonStore.imChatData.account &&
        commonStore.imChatData.token &&
        nim && 
        nim.V2NIMLoginService &&
        //@ts-ignore
        nim.V2NIMLoginService.getLoginStatus() ===
          V2NIMConst.V2NIMLoginStatus.V2NIM_LOGIN_STATUS_LOGOUT
      ) {
        nim.V2NIMLoginService.login(commonStore.imChatData.account, commonStore.imChatData.token, {
          retryCount: 5,
        }).catch((err: any) => {
          console.log("登录失败的回调", err);
        });
      }
    }, [commonStore.imChatData.account, commonStore.imChatData.token, nim]);
    // 本地默认行为参数
    const localOptions: Partial<LocalOptions> = {
      // 添加好友模式，默认需要验证
      addFriendNeedVerify,
      // 群组加入模式，默认不需要验证
      teamJoinMode: V2NIMConst.V2NIMTeamJoinMode.V2NIM_TEAM_JOIN_MODE_FREE,
      // 群组被邀请模式，默认不需要验证
      teamAgreeMode: V2NIMConst.V2NIMTeamAgreeMode.V2NIM_TEAM_AGREE_MODE_NO_AUTH,
      // 单聊消息是否显示已读未读
      p2pMsgReceiptVisible,
      // 群聊消息是否显示已读未读
      teamMsgReceiptVisible,
      // 是否需要@消息
      needMention,
      // 是否开启群管理员
      teamManagerVisible,
      // 是否显示在线离线状态
      loginStateVisible: true,
      // 是否允许转让群主
      allowTransferTeamOwner: true,
      // AI 功能是否开启
      aiVisible: true,
      // AI 消息是否开启流式输出
      aiStream: sessionStorage.getItem("aiStream")? sessionStorage.getItem("aiStream") == "true" : true,
      // 群管理员默认数量限制，默认 10 个
      teamManagerLimit: 10,
      // AI 提供者
      aiUserAgentProvider: {
        /**
         * 注册 AI 划词数字人
         */
        getAISearchUser: (users: V2NIMAIUser[]): V2NIMAIUser | void => {
          // demo 根据 accid 匹配，具体值根据业务后台配置的来
          return users.find((item) => item.accountId === "search");
        },
        /**
         * 注册 AI 翻译数字人
         */
        getAITranslateUser: (users: V2NIMAIUser[]): V2NIMAIUser | void => {
          // demo 根据 accid 匹配，具体值根据业务后台配置的来
          return users.find((item) => item.accountId === "translation");
        },
        /**
         * 注册 AI 翻译语言
         */
        getAITranslateLangs: (): string[] => {
          return ["英语", "日语", "韩语", "俄语", "法语", "德语"];
        },
      },
    }
    
    useEffect(() => {
      const _languageType = localStorage.getItem('lang') as "zh" | "en" | "ru" | "cht" | "tr" | "ara" | "pt" | "vie" | "fra" | "kor"
      const _addFriendNeedVerify = sessionStorage.getItem('addFriendNeedVerify')
      const _p2pMsgReceiptVisible = sessionStorage.getItem('p2pMsgReceiptVisible')
      const _teamMsgReceiptVisible = sessionStorage.getItem(
        'teamMsgReceiptVisible'
      )
      const _needMention = sessionStorage.getItem('needMention')
      const _teamManagerVisible = sessionStorage.getItem('teamManagerVisible')
      setCurLanguage(_languageType || 'zh')
      if (_p2pMsgReceiptVisible) {
        setP2pMsgReceiptVisible(_p2pMsgReceiptVisible === 'true')
      }
      if (_teamMsgReceiptVisible) {
        setTeamMsgReceiptVisible(_teamMsgReceiptVisible === 'true')
      }
      if (_addFriendNeedVerify) {
        setAddFriendNeedVerify(_addFriendNeedVerify === 'true')
      }
      if (_needMention) {
        setNeedMention(_needMention === 'true')
      }
      if (_teamManagerVisible) {
        setTeamManagerVisible(_teamManagerVisible === 'true')
      }
    }, [])
    const renderImDisConnected = useCallback(() => {
      let minHeight = `calc(100vh - ${pageType === '1' || pageType === '3' ? '150px' : '70px'})`
      return (
        <>
          {
            pageType === '10' ? (pathname !== '/home' && pathname !== '/' ? <Header/> : null) : <Header/>
          }
          <div 
            // style={{ minHeight }}
          >
            <AliveScope>
              {
                other.includes(pathname) || pathname.includes("/morepage") ? (
                  <Router key={pathname + vinkey} />
                ): <Router  />
              }
            </AliveScope>
          </div>
          {
            token && pageType !== '1' ? <Sider/> : null
          }
          {
            pathname !== '/epc/vin/detail' ? (
              <Footer/>
            ): null
          }
        </>
      )
    }, [token, pageType, pathname, vinkey])
  
  return (
    <div className={styles['main']}>
      {/* {contextHolder} */}
      <MainContext.Provider value={{commonStore, setCommonStore}}>
        {/* <ConfigProvider
          theme={{
            token: {
              colorPrimary
            }
          }}
        > */}
          {
            commonStore.imChatData.appKey ? <Provider
              localeConfig={languageMap[curLanguage]}
              locale={curLanguage}
              localOptions={localOptions}
              // @ts-ignore
              nim={nim}
              singleton={true}
              renderImDisConnected={renderImDisConnected}
            >
              <MainContent pageType={pageType} market={commonStore.market}/>
            </Provider> : <MainContent pageType={pageType} market={commonStore.market}/>
          }
        {/* </ConfigProvider> */}
      </MainContext.Provider>
    </div>
  )
}

let timer: any = null
let footerHeight = 0
const MainContent: React.FC<MainContentProps> = (props) => {
  const { pageType } = props
  const { commonStore, setCommonStore } = useContext(MainContext)
  let minHeight = `calc(100vh - ${pageType === '1' || pageType === '3' ? '150px' : '70px'})`
  const token = localStorage.getItem("token") || ""
  let other = ['/class', '/vin', '/code', '/oe', '/carsearch/list', '/morepage']
  const { pathname } = useLocation()
  const [ searchParams, setSearchParams ] = useSearchParams()
  const [ cookieShow, setCookieShow] = useState<boolean>(false)
  let vinkey = searchParams.get('vinkey') || ""
  useEffect(() => {
    if(commonStore.is_market) {
      if(!localStorage.getItem('cookie_privacy_pop')) {
        setCookieShow(true)
      }else {
        setCookieShow(false)
      }
    }else {
      setCookieShow(false)
    }
  }, [commonStore.is_market])

  useEffect(() => {
    window.addEventListener('resize', updateViewportHeight)
    return () => {
      window.removeEventListener("resize", updateViewportHeight)
    }
  },[])

  const [innerHegith, setInnerHegith] = useState<any>(window.innerHeight)
  const [footerHeight, setFooterHeight] = useState<any>(0)
  const hfHeight = useMemo(() => {
    let dpr = 1
    let height = 300
    let footerHeight: any = 0
    let footer = document.getElementById("footer")
    if(footer) {
      footerHeight = footer.clientHeight
    }
    console.info(footer?.clientHeight)
    if(pageType === '8') {
      if(pathname.includes("/epc")) {
        height = (60)/dpr
      }else {
        height = (156)/dpr
      }
    }else if(pageType === '7') {
      height = (120)/dpr
    }else if(pageType === '6') {
      height = (190)/dpr
    }else if(pageType === '5') {
      height = (140)/dpr
    }else if(pageType === '4') {
      height = (105)/dpr
    }else if(pageType === '3') {
      height = (150)/dpr
    }else if(pageType === '2') {
      height = (70)/dpr
    }else if(pageType === '1') {
      height = (150)/dpr
    }else if(pageType === '10') {
      height = (100)/dpr
    }
    return height
  },[pageType, pathname])
  
  
  

  const updateViewportHeight = () => {
    if(timer) {
      clearTimeout(timer)
      timer = null
    }
    timer = setTimeout(() => {
      setInnerHegith(window.innerHeight)
    },100)
  }

  const footerOnReady = () => {
    setFooterHeight(document.getElementById("footer")?.clientHeight || 0)
  }
  return (
    <>
      {
        pageType === '10' ? (pathname !== '/home' && pathname !== '/' ? <Header/> : null) : <Header/>
      }
      <div 
        className={pageType === '8' && pathname.includes("/epc") ? 'bgc-fff' : ''}
        style={{ minHeight: `${innerHegith - hfHeight - footerHeight}px` }}
      >
        <AliveScope>
          {
            other.includes(pathname) || pathname.includes("/morepage") ? (
              <Router key={pathname + vinkey} />
            ): <Router  />
          }
        </AliveScope>
      </div>
      {
        token && pageType !== '1' ? <Sider/> : null
      }
      {/* {
        pathname !== '/epc/vin/detail'  ? (
          <Footer onReady={footerOnReady} />
        ): null
      } */}
      {
        pageType === '10' ? (pathname !== '/home' && pathname !== '/' ? <Footer onReady={footerOnReady}/> : null) : <Footer onReady={footerOnReady} />
      }
      {
        commonStore.is_market && cookieShow ? <CookiePrivacy onCancel={setCookieShow}/> : null
      }
    </>
  )
}

const CookiePrivacy: React.FC<any> = (props) => {
  const intl = useIntl()
  const navigate = useNavigate()
  const { onCancel } = props
  const [open, setOpen] = useState<boolean>(false)
  const [switchInfo, setSwitchInfo] = useState<any>({
    "xn": 1,
    "gn": 1,
    "dx": 1
  })
  const closeModal = () => {
    setOpen(true)
  }
  const acceptAll = () => {
    let _switchInfo = {
      "xn": 1,
      "gn": 1,
      "dx": 1
    }
    setSwitchInfo(_switchInfo)
    localStorage.setItem('cookie_privacy_pop', '1')
    localStorage.setItem('cookie_switch', JSON.stringify(_switchInfo))
    setOpen(false)
    if(onCancel) {
      onCancel(false)
    }
  }
  const declineAll = () => {
    let _switchInfo = {
      "xn": 0,
      "gn": 0,
      "dx": 0
    }
    setSwitchInfo(_switchInfo)
    localStorage.setItem('cookie_privacy_pop', '1')
    localStorage.setItem('cookie_switch', JSON.stringify(_switchInfo))
    setOpen(false)
    if(onCancel) {
      onCancel(false)
    }
  }
  const acceptMy = () => {
    localStorage.setItem('cookie_privacy_pop', '1')
    localStorage.setItem('cookie_switch', JSON.stringify(switchInfo))
    setOpen(false)
    if(onCancel) {
      onCancel(false)
    }
  }
  const switchChange = (checked: boolean, type: string) => {
    let _switchInfo = JSON.parse(JSON.stringify(switchInfo))
    _switchInfo[type] = checked ? 1 : 0
    setSwitchInfo(_switchInfo)
  }
  return (
    <>
      <div className={styles['privacy-wrap']}>
        <div className={styles['privacy-pop']}>{intl.formatMessage({id: '我们使用Cookie以允许我们网站的正常工作、个性化设计内容和广告、提供社交媒体功能并分析流量。我们还同社交媒体、广告和分析合作伙伴并分享有关您使用我们网站的信息'})}</div>
        <div className={styles['privacy-bottom']}>
          <div className={styles['set-btn']} onClick={() => setOpen(true)}>{intl.formatMessage({id: 'Cookie设置'})}</div>
          <div className={styles['primary-btn']} onClick={acceptAll}>{intl.formatMessage({id: '接受所有Cookie'})}</div>
        </div>
      </div>
      {
        open ? <Modal
          title=" "
          open={open}
          width={560}
          footer={null}
          onCancel={closeModal}
        >
          <div className={styles['privacy-modal']}>
            <div className={styles['privacy-title']}>{intl.formatMessage({id: '隐私偏好中心'})}</div>
            <div className={styles['privacy-content']}>{intl.formatMessage({id: '您访问任何网站时，网站都可能在您的浏览器上存储或检索信息，大多数是以Cookie的形式进行。此信息可能与您、您的偏好、您的设备相关，或者该信息被用于使网站按照您期望的方式工作。这些信息通常不会直接识别您，但它可为您提供更多个性化的Web体验。您可以选择不允许使用某些类型的Cookie。单击不同类型标题以了解更多信息并更改默认设置。但是，您应该知道，阻止某些类型的Cookie可能会影响您的网站体验和我们能够提供的服务。'})}</div>
            {/* <div className={styles['to-more']} onClick={() => navigate("/protocol/privacy")}>{intl.formatMessage({id: '更多信息'})}</div> */}
            <div className={styles['primary-btn']} onClick={acceptAll}>{intl.formatMessage({id: '全部允许'})}</div>
            <div className={styles['privacy-title']} style={{marginTop: 20, marginBottom: 20}}>{intl.formatMessage({id: '管理许可偏好'})}</div>
            <div className={styles['switch-group']}>
              <div className={styles['switch-item']}>
                <div className={styles['switch-lf']}>
                  <PlusOutlined style={{fontSize: 14, color: '#5C5C5C'}}/>
                  <span className={styles['switch-label']}>{intl.formatMessage({id: '绝对必要的Cookie'})}</span>
                </div>
                <div className={styles['switch-rt']}>
                  <div className={styles['blue-btn']} onClick={acceptAll}>{intl.formatMessage({id: '始终处于活动状态'})}</div>
                </div>
              </div>
              <div className={styles['switch-item']}>
                <div className={styles['switch-lf']}>
                  <PlusOutlined style={{fontSize: 14, color: '#5C5C5C'}}/>
                  <span className={styles['switch-label']}>{intl.formatMessage({id: '性能Cookie'})}</span>
                </div>
                <div className={styles['switch-rt']}>
                  <Switch checked={switchInfo.xn ? true : false} onChange={(checked) => switchChange(checked, 'xn')}/>
                </div>
              </div>
              <div className={styles['switch-item']}>
                <div className={styles['switch-lf']}>
                  <PlusOutlined style={{fontSize: 14, color: '#5C5C5C'}}/>
                  <span className={styles['switch-label']}>{intl.formatMessage({id: '功能Cookie'})}</span>
                </div>
                <div className={styles['switch-rt']}>
                  <Switch checked={switchInfo.gn ? true : false} onChange={(checked) => switchChange(checked, 'gn')}/>
                </div>
              </div>
              <div className={styles['switch-item']}>
                <div className={styles['switch-lf']}>
                  <PlusOutlined style={{fontSize: 14, color: '#5C5C5C'}}/>
                  <span className={styles['switch-label']}>{intl.formatMessage({id: '定向Cookie'})}</span>
                </div>
                <div className={styles['switch-rt']}>
                  <Switch checked={switchInfo.dx ? true : false} onChange={(checked) => switchChange(checked, 'dx')}/>
                </div>
              </div>
            </div>
            <div className={styles['privacy-bottom']}>
              <div className={styles['default-btn']} onClick={declineAll}>{intl.formatMessage({id: '全部拒绝'})}</div>
              <div className={styles['primary-btn']} onClick={acceptMy}>{intl.formatMessage({id: '确认我的选择'})}</div>
            </div>
          </div>
        </Modal> : null
      }
    </>
  )
}
export default Main